import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

// Connects to data-controller="direct-upload"
export default class extends Controller {
  static targets = ["fileInput", "signedId", "submitButton"];
  static values = { directUploadUrl: String };

  connect() {
    this.toggleSubmit(!!this.signedIdTarget.value);
  }

  upload() {
    const fileInput = this.fileInputTarget;
    const file =
      fileInput.files?.[0] ||
      fileInput.shadowRoot?.querySelector("input[type='file']")?.files?.[0];

    this.signedIdTarget.value = "";
    this.toggleSubmit(false);

    if (!file) return;

    const uploader = new DirectUpload(file, this.directUploadUrlValue);

    uploader.create((error, blob) => {
      if (error) {
        console.error(error);
        return;
      }

      this.signedIdTarget.value = blob.signed_id;
      this.toggleSubmit(true);
    });
  }

  toggleSubmit(enabled) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !enabled;
    }
  }
}
